// 站点级 SEO 工具：把静态 HTML 中的默认（简体中文）元信息切换为当前界面语言。
// Google 等会执行 JS 的爬虫可据此拿到本地化的 <title> / meta description / keywords。
const CANONICAL_URL = "https://11.aliving.stream/";

const OG_LOCALES: Record<string, string> = {
  ar: "ar",
  "ca-ES": "ca_ES",
  cs: "cs_CZ",
  da: "da_DK",
  de: "de_DE",
  el: "el_GR",
  en: "en_US",
  "en-AU": "en_AU",
  "en-CA": "en_CA",
  "en-GB": "en_GB",
  es: "es_ES",
  fa: "fa_IR",
  fi: "fi_FI",
  fr: "fr_FR",
  ga: "ga_IE",
  gd: "gd",
  gl: "gl_ES",
  gu: "gu_IN",
  hi: "hi_IN",
  hu: "hu_HU",
  id: "id_ID",
  it: "it_IT",
  ja: "ja_JP",
  ko: "ko_KR",
  lb: "lb_LU",
  lt: "lt_LT",
  lv: "lv_LV",
  my: "my_MM",
  ne: "ne_NP",
  nl: "nl_NL",
  no: "no_NO",
  pl: "pl_PL",
  pt: "pt_PT",
  "pt-BR": "pt_BR",
  ro: "ro_RO",
  ru: "ru_RU",
  sk: "sk_SK",
  sl: "sl_SI",
  sq: "sq_AL",
  sr: "sr_RS",
  sv: "sv_SE",
  ta: "ta_IN",
  th: "th_TH",
  tr: "tr_TR",
  uk: "uk_UA",
  vi: "vi_VN",
  zh: "zh_CN",
  "zh-CN": "zh_CN",
  "zh-SG": "zh_CN",
  "zh-TW": "zh_TW",
  "zh-HK": "zh_TW",
  "zh-MO": "zh_TW",
};

const ogLocaleFor = (locale: string): string =>
  OG_LOCALES[locale] || OG_LOCALES[locale.split("-")[0]] || locale.replace("-", "_");

function setMeta(attr: "name" | "property", key: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/** 按当前语言同步页面标题/描述/关键词；canonical / og:url / og:image 由静态 HTML 固定提供。 */
export function applySeo(locale: string, title: string, description: string, keywords?: string[]): void {
  document.title = title;
  setMeta("name", "description", description);
  if (keywords && keywords.length > 0) setMeta("name", "keywords", keywords.join(", "));
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:locale", ogLocaleFor(locale));
  const canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (canonical) canonical.setAttribute("href", CANONICAL_URL);
}